import type { HotelListQuery } from "@/lib/gql/__generated__/graphql";

import { CompanyTopHotelList as HotelList } from "./ui/hotel-list";
import { CompanyTopInnerHeader as InnerHeader } from "./ui/inner-header";

type Props = {
	hotelList: HotelListQuery["hotelList"];
};

export const CompanyTopPresenter = ({ hotelList }: Props) => {
	return (
		<main className="min-h-screen space-y-12 bg-zinc-100 px-8 py-12 lg:px-28 lg:py-24">
			<InnerHeader />
			<HotelList hotelList={hotelList} />
		</main>
	);
};

CompanyTopPresenter.displayName = "CompanyTopPresenter";
